import React, { FC, useEffect, useState } from 'react';
import SecondTitle from 'modules/shared/components/second-title';
import ProductSectionBox from 'modules/product/views/components/product-section-box';
import ProductOfferWrapper from 'modules/product/views/components/product-offers/product-offer-wrapper';
import OfferInterface from 'interfaces/offer.interface';
import { useFetch } from 'hooks/use-fetch';

interface ProductOffersSimilarProps {
    productId: number;
    productDealerId: number;
    isMobile?: boolean;
}

const ProductOffersSimilar: FC<ProductOffersSimilarProps> = ({
    productId,
    productDealerId,
    isMobile = false
}) => {
    const [similarOffers, setSimilarOffers] = useState<OfferInterface[]>([]);
    const { error, get } = useFetch(`/api/product/similar-offers?id=${productId}&dealerId=${productDealerId}`, { method: 'GET' });

    useEffect(() => {
        get().then((offers: OfferInterface[]) => {
            setSimilarOffers(offers);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (error || !similarOffers?.length) {
        return null;
    }

    return (
        <>
            <SecondTitle text="Podobne oferty">({similarOffers.length})</SecondTitle>
            <section id="oferty" className="tab-section">
                <ProductSectionBox
                    headerText="Wybrane przez Skąpiec.pl"
                    padding="lg"
                >
                    {similarOffers.map(offer => (
                        <ProductOfferWrapper
                            key={offer.id}
                            offer={offer}
                            isImage={!isMobile}
                        />
                    ))}
                </ProductSectionBox>
            </section>
        </>
    );
};

export default ProductOffersSimilar;
